import TableComponent from '../../Common/Charts/TableCharts';
import { number } from '../../Common/Util/number';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';
import { useSanitizeData } from '../Common/hooks/useSanitizeData';
import '../Common/Styles/Ciha.css'

export const TopMortalityCidsTable = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const tableColumns = [
        {
            key: 'cid',
            header: 'CID',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400'},  
            formatter: (value) => ( <span className="table-badge"> {value} </span> )
        },
        {
            key: 'nome',
            header: 'Nome',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total_casos',
            header: 'Total de Casos',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'total_obitos',
            header: 'Total Óbitos',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'taxa_morte_pct',
            header: 'Taxa de Mortalidade (%)',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400', },
            formatter: (value) => <span style={{ color: 'red' }}>{`${number.formatToBRNumber(value)}%`}</span>
        }
    ];

    const rawData = chartData?.topMortalityCids || [];

    const sanitizedData = useSanitizeData(rawData);

    return (
            <TableComponent
                className="no-spacing-table"
                data={sanitizedData}
                columns={tableColumns}
                title="CIDs com maior mortalidade"
                formatNumber={number.formatToBRNumber}
                
            />
        
    )
};